module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row1"
  }, [_c('div', {
    staticClass: "col1"
  }, [_c('grid', [_c('grid-item', {
    attrs: {
      "link": "/ecms"
    }
  }, [_c('div', [_c('p', {
    staticClass: "title-font"
  }, [_vm._v("ECMS系统")]), _vm._v(" "), _c('img', {
    staticClass: "img-ecms",
    attrs: {
      "src": require("../../assets/images/ecms.png")
    }
  })])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col2"
  }, [_c('div', {
    staticClass: "col2-1"
  }, [_c('grid', [_c('grid-item', {
    attrs: {
      "link": {
        path: '/notice',
        query: {
          type: 'notice1'
        }
      }
    }
  }, [_c('div', [_c('p', {
    staticClass: "title-font"
  }, [_vm._v("通知公告")]), _vm._v(" "), _c('img', {
    staticClass: "img-notice",
    attrs: {
      "src": require("../../assets/images/notice.png"),
      "width": "44",
      "height": "44"
    }
  })])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col2-2"
  }, [_c('grid', [_c('grid-item', {
    attrs: {
      "link": {
        path: '/news',
        query: {
          type: 'notice2'
        }
      }
    }
  }, [_c('div', [_c('span', {
    staticClass: "title-font"
  }, [_vm._v("公司新闻")]), _vm._v(" "), _c('img', {
    staticClass: "img-pilot",
    attrs: {
      "src": require("../../assets/images/pilot.png"),
      "width": "44",
      "height": "44"
    }
  })])])], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d78d4b8a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/HomeList.vue
// module id = tv2Z
// module chunks = 1